import { IValidBidRequest } from '../../../../../typings/IPrebid'
import { MediaType } from '../../../../enums/MediaType'
import { queryParamHas } from '../../../../helpers/getQueryParam'

const nativeBannerTest = queryParamHas('test', 'nativeTestAd')
const nativeVideoTest = queryParamHas('test', 'nativeTestVideoAd')
const nativeTestAds = {}
/** Cache a copy of a native test bid response to use later */
export function cacheNativeTestBid(bidRequests: Array<IValidBidRequest>) {
  const nativeReq = bidRequests.find((req) => req.isNative)
  if (
    !nativeReq ||
    !(nativeBannerTest || nativeVideoTest) ||
    !nativeReq.bidId
  ) {
    return
  }
  let testNative = testBannerNativeResponse

  if (nativeVideoTest) {
    testNative = testVideoNativeResponse
  }

  nativeTestAds[nativeReq.bidId] = createTestResponse(
    nativeReq,
    JSON.stringify(testNative)
  )
}

/** Insert a test native response in body, if enabled and present */
export function getNativeTestResponse(body: Array<any>, request) {
  const { data } = request
  const nativeReq = data.bids.find((bid) => bid.isNative)
  if (!(nativeBannerTest || nativeVideoTest) || !nativeReq) {
    return
  }
  const nativeBid = nativeTestAds[nativeReq.bidId]
  if (nativeBid) {
    body.push(nativeBid)
  }
}

const createTestResponse = (bid, adm: string) => {
  const bidId = bid.bidId
  return {
    id: bidId,
    mediaType: MediaType.native,
    bidder: 'rubicon',
    seatbid: [
      {
        bid: [
          /** Triplelift example ad */
          // {
          //   "id": "57136181000546132780",
          //   "impid": bidId,
          //   "price": 10.652,
          //   "nurl": "https://tlx.3lift.com/s2sn/notify?px=1&pr=${AUCTION_PRICE}&ts=1613578682&aid=57136181000546132780&ec=4945_84215_455422_ssl&n=Gt0DaHR0cHM6Ly9ydGItdXN3Lm1mYWRzcnZyLmNvbS9pbXBfczJzL3YyL1NpNUZzNFJVSDdiRzMyX0xoTkg2RWFfTl9YWlZfU1hjMlNUcDlzVS15Mm1oaWVHaHBkMHhVTWRYeHoyQTU2dTRBUmdWU2dfQ0dLNXRMdmJaZDZVQVRsZERFRzlUb1VEYmxCOTQ3RDExODRxek5BNjJHUDNNV0l6LXdUc2s3dmFUaE5XMVYzOHpwRU1menVxeW43ckh1RWVCMVUxSkFjdDBENm5SOWZVdEVibGJWUTFYT2xJaEF4NjAxMU9Iel9HYmZZUUFKMVpZbjFvcHFiTlhtZ2pHNmJyeFJjX0Uzd3hTaFU4Nko5V3ZvLU9wbzc4WVNmVXhZQnhyT0p1SC1fWXZtWUZvVUdpS0VWQkFJNkQ5NFdhbXVsZXpQV05pWG00cjdpWTM0ckRubVNUTll6MFpCTi00dzJQakVUMW1YaDRzT3BNeUdmNEVEM29oSnhJM0JEb2FraHBWYVlUOHVBLzIuMDY1L05BNmdhYy1zTlJoeUd5cjVjY1NaVGhiM2pHSVhCSnBKcTh6NkNJanlOSnpfRk9GM0hvd3MyX3VfYjlXVFJDRU5vTGo5clc3Rk5JTk4%2FcT0x8gKpAQgAEhQ1NzEzNjE4MTAwMDU0NjEzMjc4MBgAIAEo0SYw95EFQAFIAFAAYAFoAnCYkhOQAQCYAQCoAcr%2BjgawAZEQuAGjCMAB9AzIAZEQ4AGtCPABAPgBkRCAAvQMiAKtCJECAAAAAAAA8D%2BZApqZmZmZmck%2FoQIAAAAAAADwP6gCALACAcgCAtgCAPECZmZmZmZm5j%2F4AtEmkAMCmAMBoAMAuAP72A3AAwD4AhiIAwCSAwQzMWFj",
          //   "adm": "{\"native\":{\"ver\":\"1.1\",\"assets\":[{\"id\":4,\"data\":{\"type\":1,\"value\":\"cat food expose\"}},{\"id\":1,\"title\":{\"text\":\"3 Ways Your Cat Asks For Help\"}},{\"id\":5,\"data\":{\"type\":2,\"value\":\"3 Ways Your Cat Asks for Help\"}},{\"id\":2,\"img\":{\"type\":3,\"url\":\"https://images.3lift.com/12828490.jpg\",\"w\":600,\"h\":600}},{\"id\":7,\"video\":{}}],\"link\":{\"url\":\"https://rtb-usw.mfadsrvr.com/click/Si5Fs4RUH7bG32_LhNH6Ea_N_XZV_SXc2STp9sU-y2mhieGhpd0xUMdXxz2A56u4ARgVSg_CGK5tLvbZd6UATldDEG9ToUDblB947D1184qzNA62GP3MWIz-wTsk7vaThNW1V38zpEMfzuqyn7rHuEeB1U1JAct0D6nR9fUtEblbVQ1XOlIhAx6011OHz_GbfYQAJ1ZYn1opqbNXmgjG6brxRc_E3wxShU86J9Wvo-Opo78YSfUxYBxrOJuH-_YvmYFoUGiKEVBAI6D94WamulezPWNiXm4r7iY34rDnmSTNYz0ZBN-4w2PjET1mXh4sOpMyGf4ED3ohJxI3BDoakhpVaYT8uA///\",\"clicktrackers\":[\"https://eb2.3lift.com/ec?bc=2.065&pr=%24%7BAUCTION_PRICE%7D&brid=313624&bmid=4945&biid=4945&aid=57136181000546132780&bcud=2065&sid=84215&ts=1613578682\"]},\"eventtrackers\":[{\"event\":1,\"method\":1,\"url\":\"https://rtb-usw.mfadsrvr.com/sync?ssp=triplelift&seller_network=triplelift_&bid_id=b64fc982-835c-4000-949c-9a7337143786&initiator=me\"},{\"event\":1,\"method\":1,\"url\":\"https://eb2.3lift.com/r?rr=creative&bc=2.065&pr=%24%7BAUCTION_PRICE%7D&brid=313624&bmid=4945&biid=4945&aid=57136181000546132780&bcud=2065&sid=84215&ts=1613578682\"},{\"event\":2,\"method\":1,\"url\":\"https://eb2.3lift.com/ev?bc=2.065&pr=%24%7BAUCTION_PRICE%7D&brid=313624&bmid=4945&biid=4945&aid=57136181000546132780&bcud=2065&sid=84215&ts=1613578682\"}],\"privacy\":\"https://optout.aboutads.info/\"}}",
          //   "adomain": [
          //     "www2.catfoodexpose.com"
          //   ],
          //   "crid": "4945_84215_455422_ssl",
          //   exp: 300
          // }
          {
            id: '12345',
            impid: bidId,
            price: 10.5,
            unadjustedPrice: 10.5,
            nurl: 'http://placehold.it/1x1?nurl',
            adm,
            h: 1,
            w: 1,
            exp: 300,
            crid: '12345',
            cid: '12345'
          }
        ]
      }
    ]
  }
}

const testVastTag = `
<VAST version="4.0" xmlns:xs="http://www.w3.org/2001/XMLSchema" xmlns="http://www.iab.com/VAST">
  <Ad id="20001" sequence="1" conditionalAd="false">
    <InLine>
      <AdSystem version="4.0">iabtechlab</AdSystem>
      <Error>http://example.com/error</Error>
      <Impression id="Impression-ID">http://example.com/track/impression</Impression>
      <Pricing model="cpm" currency="USD">
        <![CDATA[ 25.00 ]]>
      </Pricing>
      <AdTitle>Inline Simple Ad</AdTitle>
      <AdVerifications></AdVerifications>
      <Advertiser>IAB Sample Company</Advertiser>
      <Category authority="http://www.iabtechlab.com/categoryauthority">AD CONTENT description category</Category>
      <Creatives>
        <Creative id="5480" sequence="1" adId="2447226">
          <UniversalAdId idRegistry="Ad-ID" idValue="8465">8465</UniversalAdId>
          <Linear>
            <TrackingEvents>
              <Tracking event="start">http://example.com/tracking/start</Tracking>
              <Tracking event="firstQuartile">http://example.com/tracking/firstQuartile</Tracking>
              <Tracking event="midpoint">http://example.com/tracking/midpoint</Tracking>
              <Tracking event="thirdQuartile">http://example.com/tracking/thirdQuartile</Tracking>
              <Tracking event="complete">http://example.com/tracking/complete</Tracking>
              <Tracking event="progress" offset="00:00:10">http://example.com/tracking/progress-10</Tracking>
            </TrackingEvents>
            <Duration>00:00:16</Duration>
            <MediaFiles>
              <MediaFile id="5241" delivery="progressive" type="video/mp4" bitrate="2000" width="1280" height="720" minBitrate="1500" maxBitrate="2500" scalable="1" maintainAspectRatio="1" codec="H.264">
                <![CDATA[https://iab-publicfiles.s3.amazonaws.com/vast/VAST-4.0-Short-Intro.mp4]]>
              </MediaFile>
              <MediaFile id="5244" delivery="progressive" type="video/mp4" bitrate="1000" width="854" height="480" minBitrate="700" maxBitrate="1500" scalable="1" maintainAspectRatio="1" codec="H.264">
                <![CDATA[https://iab-publicfiles.s3.amazonaws.com/vast/VAST-4.0-Short-Intro-mid-resolution.mp4]]>
              </MediaFile>
              <MediaFile id="5246" delivery="progressive" type="video/mp4" bitrate="600" width="640" height="360" minBitrate="500" maxBitrate="700" scalable="1" maintainAspectRatio="1" codec="H.264">
                <![CDATA[https://iab-publicfiles.s3.amazonaws.com/vast/VAST-4.0-Short-Intro-low-resolution.mp4]]>
              </MediaFile>
            </MediaFiles>
            <VideoClicks>
              <ClickThrough id="blog">
                <![CDATA[https://iabtechlab.com]]>
              </ClickThrough>
            </VideoClicks>
          </Linear>
        </Creative>
      </Creatives>
    </InLine>
  </Ad>
</VAST>
`

const testNativeVideoAsset = {
  id: 7,
  video: {
    vasttag: testVastTag
  }
}

const testNativeImageAsset = {
  id: 2,
  img: {
    url: 'https://picsum.photos/300/225',
    w: 300,
    h: 225,
    ext: {
      appnexus: {
        prevent_crop: 0
      }
    }
  }
}

const getTestNative = (assets: Array<object> = []) => ({
  assets: [
    ...assets,
    {
      id: 4,
      data: {
        value: 'Mediavine'
      }
    },
    {
      id: 1,
      title: {
        text: 'Mediavine Test Native'
      }
    },
    {
      id: 5,
      data: {
        value:
          "You are seeing a test native advertisement. It is being displayed because we've detected the query param test set to `nativeTestAd`. I hope this ad finds you well!"
      }
    },
    {
      id: 22,
      data: {
        value: 'Call To Action'
      }
    }
  ],
  link: {
    url: 'https://mediavine.com',
    clicktrackers: ['https://placehold.it/1x1?clicktracker']
  },
  eventtrackers: [
    {
      method: 1,
      event: 1,
      url: 'https://placehold.it/1x1?ImpressionTrackerPixel'
    },
    {
      method: 2,
      event: 1,
      url: 'https://placehold.it/1x1?ImpressionTrackerScript'
    },
    { method: 1, event: 2, url: 'https://placehold.it/1x1?ViewTrackerPixel' },
    { method: 2, event: 2, url: 'https://placehold.it/1x1?ViewTrackerScript' }
  ],
  imptrackers: ['https://placehold.it/1x1?imptracker'],
  jstracker:
    "<script src='https://placehold.it/1x1?jstracker' type='application/javascript'></script>"
})

const testVideoNativeResponse = {
  ...getTestNative([testNativeVideoAsset])
}

const testBannerNativeResponse = {
  ...getTestNative([testNativeImageAsset])
}
